import { Period } from 'revlock-webutils'
import shortid from 'shortid'
import FullMonthRatablePlan from './plan/FullMonthRatablePlan'
import Modified30_360Plan from './plan/Modified30_360Plan'
import FixedMonthRatablePlan from './plan/FixedMonthRatablePlan'
import DailyRatablePlan from './plan/DailyRatablePlan'
import ApportionedRatablePlan from './plan/ApportionedRatablePlan'

/**
 * Validate that the given plan is valid
 *
 * @param plan
 */
export function assertValidPlan(plan){
	for(let p of plan){
		if(!p || !p.actgPeriod || isNaN(p.planAmount)){
			throw new Error("Created an invalid plan");
		}
	}
}

/**
 * Validate that the provided revenue arrangement is valid
 *
 * @param ra
 * @param type
 */
export function assertValidArrangement(ra, type ){
	for (let item of ra.revenueArrangementItem) {
		if (item.plan) {
			if (!Array.isArray(item.plan)) {
				throw new Error("No valid plan")
			}
			for (let p of item.plan) {
				if (!p.period && !p.actgPeriod) {
					throw new Error('Invalid Revenue Arrangement')
				}

				if (type === 'w') {
					if (p.actgPeriod) {
						throw new Error('Invalid Revenue Arrangement')
					}

					if (!p.period) {
						throw new Error('Invalid Revenue Arrangement')
					}
				}
				if (type === 'r') {
					if (!p.actgPeriod?.period) {
						throw new Error('Invalid Revenue Arrangement')
					}
				}
			}
		}
	}
}

export function getAutoCreateSSP(orgConfig) {
	const autoCreateSSPConfig = orgConfig.find(config => config.id === 'properties/auto-create-ssp');
	const autoCreateSSP = autoCreateSSPConfig && autoCreateSSPConfig.value || false

	return autoCreateSSP
}

export function buildPlan(revenueArrangementItem, salesOrder, orgConfig, productRevenue, calendarConfig) {
	let startDate = revenueArrangementItem.deliveryStartDate;
	let endDate = revenueArrangementItem.deliveryEndDate;
	let originalBooking = productRevenue;
	// delayed revenue is true our plan is 0 (in modification this will be adjustment)

	const d1 = orgConfig.find(config => config.id === "properties/ratable_plan_type");
	const planType = d1 && d1.value || "default";

	const d2 = orgConfig.find(config => config.id === "properties/ratable_end_date_inclusive")
	const endDateInclusive = d2 && d2.value || false;

	const d3 = orgConfig.find(cfg => cfg.id === 'properties/max-contract-years')
	const maxContractYears = (d3 && d3.value && Number(d3.value)) || 20

	if (calendarConfig && calendarConfig.type === 'retail') {
		if (planType !== 'daily')
			throw new Error("Retail calendar can only be used with a daily plan!");
	}

	let plan;
	if (planType === 'monthly_endmonth_exclusive') {
		plan = FullMonthRatablePlan.buildPlan(startDate,
			endDate, originalBooking, calendarConfig)
	} else if (planType === 'fixed') {

		const d3 = orgConfig.find(config => config.id === "properties/ratable_start_exact_days")
		const exactDays = d3 && d3.value || false;

		if (exactDays) {
			let { term } = revenueArrangementItem.salesOrderItem;
			plan = Modified30_360Plan.buildPlan(startDate, endDate, originalBooking, endDateInclusive, calendarConfig, term)
		}
		else {
			plan = FixedMonthRatablePlan.buildPlan(startDate,
				endDate, originalBooking, endDateInclusive, exactDays,
				calendarConfig)
		}
	} else if (planType === 'daily') {
		plan = DailyRatablePlan.buildPlan(startDate,
			endDate, originalBooking, endDateInclusive,
			calendarConfig)
	}
	else {
		plan = ApportionedRatablePlan.buildPlan(startDate, endDate,
			originalBooking, endDateInclusive, calendarConfig)
	}

	plan = (plan.length > 12 * maxContractYears) ? plan.slice(0, 12 * maxContractYears) : plan;
	//do not support more than maxContractYears years

	assertValidPlan(plan)

	return plan;
}

export function prefillZeroAtStart(plan, salesOrder, calendarConfig) {

	if (plan.length === 0) return

	const firstPlanActgPeriod =
		plan[0].actgPeriod;

	const arrangementEffectivePeriod =
		Period.toActgPeriod(salesOrder.revenueArrangement[0].effectiveDate, calendarConfig);

	if (arrangementEffectivePeriod.period >= firstPlanActgPeriod.period)
		return;

	const periods =
		Period.periodsBetween(arrangementEffectivePeriod.period, firstPlanActgPeriod.period, true);

	if (periods.length === 0) return;

	let toAdd = []
	let actgPeriod = firstPlanActgPeriod;
	for (let period of periods) {
		actgPeriod = actgPeriod.get(period);

		toAdd.push({
			actgPeriod,
			planAmount: 0,
		});
	}

	plan.unshift(...toAdd);

	assertValidPlan(plan)
}